import { render, staticRenderFns } from "./FirmaPswUpdate.vue?vue&type=template&id=3d4407f0&scoped=true&"
import script from "./FirmaPswUpdate.vue?vue&type=script&lang=js&"
export * from "./FirmaPswUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4407f0",
  null
  
)

export default component.exports